import { render, staticRenderFns } from "./PromotionsCenter.vue?vue&type=template&id=6b9860c0&scoped=true"
import script from "./PromotionsCenter.vue?vue&type=script&lang=js"
export * from "./PromotionsCenter.vue?vue&type=script&lang=js"
import style0 from "./PromotionsCenter.vue?vue&type=style&index=0&id=6b9860c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9860c0",
  null
  
)

export default component.exports